import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { TrendingUp, Clock, DollarSign, Users } from 'lucide-react';

export default function ROI() {
  const { isDark } = useTheme();

  const stats = [
    {
      icon: TrendingUp,
      value: "+35%",
      label: "Productivité équipe",
      description: "Mesurée sur 100+ clients"
    },
    {
      icon: Clock,
      value: "-45%",
      label: "Temps improductif",
      description: "Grâce au timer intelligent"
    },
    {
      icon: DollarSign,
      value: "0 erreur",
      label: "Calcul des commissions",
      description: "Automatisation complète"
    },
    {
      icon: Users,
      value: "100%",
      label: "Visibilité équipe",
      description: "Supervision en temps réel"
    }
  ];

  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className={`text-3xl lg:text-4xl font-bold mb-4 ${
            isDark ? 'text-white' : 'text-gray-900'
          }`}>
            Des résultats mesurables
          </h2>
          <p className={`text-lg ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
            Nos clients constatent une amélioration significative dès le premier mois
          </p>
        </div>

        {/* Statistiques */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div key={index} className="text-center">
                <div className={`w-16 h-16 rounded-2xl ${
                  isDark ? 'bg-gray-900' : 'bg-gray-100'
                } flex items-center justify-center mx-auto mb-4`}>
                  <Icon className="w-8 h-8 text-primary-600" />
                </div>
                <p className="text-4xl font-bold text-primary-600 mb-2">
                  {stat.value}
                </p>
                <p className={`text-lg font-semibold mb-1 ${
                  isDark ? 'text-white' : 'text-gray-900'
                }`}>
                  {stat.label}
                </p>
                <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                  {stat.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* ROI Calculator preview */}
        <div className={`p-8 rounded-2xl border ${
          isDark ? 'bg-gray-900 border-gray-800' : 'bg-gray-50 border-gray-200'
        }`}>
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className={`text-2xl font-bold mb-4 ${
                isDark ? 'text-white' : 'text-gray-900'
              }`}>
                Calculez votre ROI
              </h3>
              <p className={`text-lg mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                Pour une équipe de 10 agents, Insight360 génère en moyenne :
              </p>
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <span className={isDark ? 'text-gray-300' : 'text-gray-600'}>
                    Gain de productivité
                  </span>
                  <span className="text-xl font-bold text-primary-600">+35%</span>
                </div>
                <div className="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                  <div className="w-[35%] h-full bg-primary-600 rounded-full"></div>
                </div>
                
                <div className="flex justify-between items-center">
                  <span className={isDark ? 'text-gray-300' : 'text-gray-600'}>
                    Réduction temps improductif
                  </span>
                  <span className="text-xl font-bold text-primary-600">-45%</span>
                </div>
                <div className="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                  <div className="w-[45%] h-full bg-emerald-600 rounded-full"></div>
                </div>

                <div className="flex justify-between items-center">
                  <span className={isDark ? 'text-gray-300' : 'text-gray-600'}>
                    Économies annuelles estimées
                  </span>
                  <span className="text-xl font-bold text-primary-600">24 500€</span>
                </div>
              </div>
            </div>
            
            <div className={`p-6 rounded-xl ${
              isDark ? 'bg-gray-800' : 'bg-white'
            }`}>
              <p className={`text-sm font-medium mb-4 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                Simulation pour une équipe de 10 agents
              </p>
              <div className="space-y-3">
                <div className="flex justify-between">
                  <span className={isDark ? 'text-gray-300' : 'text-gray-600'}>Sans Insight360</span>
                  <span className={isDark ? 'text-gray-300' : 'text-gray-600'}>70 000€</span>
                </div>
                <div className="flex justify-between font-bold">
                  <span className="text-primary-600">Avec Insight360</span>
                  <span className="text-primary-600">45 500€</span>
                </div>
                <div className="border-t border-gray-200 dark:border-gray-700 my-2"></div>
                <div className="flex justify-between text-lg font-bold">
                  <span className={isDark ? 'text-white' : 'text-gray-900'}>Économies</span>
                  <span className="text-emerald-600">24 500€</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}